import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import IncompleteSettingsModal from "../../components/Common/IncompleteSettingsModal/IncompleteSettingsModal.js";
import useIncompleteSettings from "./scripts/hook";
import HeroLoader from "../../components/HeroLoader/HeroLoader";
import BottomNavigation from "../../components/BottomNavigation/BottomNavigation";

const User = () => {
  const navigate = useNavigate();
  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(false);
  useEffect(() => {
    getAuth().onAuthStateChanged((result) => {
      if (result == null) {
        setIsUserLoggedIn(false);
        // window.location.pathname = "/";
      } else {
        setIsUserLoggedIn(true);
      }
    });
  }, []);

  const [AuthUser, ClientData, ListedImage] = useIncompleteSettings();

  if (IsUserLoggedIn)
    return (
      <>
        {/* <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div> */}

        {/* <div id="main-wrapper"> */}
        {/* <div> */}
        <IncompleteSettingsModal
          AuthUser={AuthUser}
          ClientData={ClientData}
          ListedImage={ListedImage}
        />
        <Header />
        <Sidebar />
        <BottomNavigation />
        <Outlet />

        {/* <div className="footer d-none">
          <div className="copyright">
            <p>
              Copyright © Designed &amp; Developed by{" "}
              <a href="#" target="_blank">
                Real Estate
              </a>{" "}
              2021
            </p>
          </div>
        </div> */}
        {/* </div> */}
        {/* </div> */}
      </>
    );
  else return <HeroLoader />;
};

export default User;
